module.exports = __webpack_public_path__ + "img/teacher.7557cef0.webp";